import React from 'react';
import { useTranslation } from 'react-i18next';
import { useContext, useState } from 'react';
import { AppContext } from '/@/app/AppContext';
import { Paper, Box, Button, Collapse, Link } from '@mui/material';
import { formatDate } from '/@/app/utils';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTheme } from "@mui/material";
import { Linkify } from '/@/app/linkify';
import { userFlowState } from '/@/app/states/userFlowState';
import { messageStackState } from '/@/app/states/messageStackState';
import { route } from '/@/app/routes';


export const UpdateAnnouncements = ({mode}) => {
    const { t, i18n } = useTranslation();
    const { bootstrapData } = useContext(AppContext);
    const { featureEnabled } = useContext(AppContext);
    const lang=i18n.language;
    const algorithm = bootstrapData.active_algorithm?.[lang];
    const panel = bootstrapData.active_panel;
    const updateNotices = bootstrapData.update_notices[lang];
    const theme = useTheme();

    // updates on page reload
    const canRecalculate = panel.algorithm_id !=  algorithm.id;

    let [recalculating, setRecalculating] = useState(false);
    const calculateAll = () => {
        if (!featureEnabled('general_analytics')) {
            messageStackState.addMessage({
                tags: "warning",
                text: t("Обновляем")+'. '+t("Для полного пересчёта")+' '+t("подключите подписку")+'.',
                content: (<Box>
                    {t("Обновляем")+'. '+t("Для полного пересчёта")} {" "}
                    <Link
                        sx={{ color: 'white', fontWeight: 'bold' }}
                        href={route('/subscriptions/')}
                    >{t("подключите подписку")}.</Link>
                </Box>),
            })
        }

        if (recalculating) {
            return;  // prevent double click
        }
        setRecalculating(true);
        if (featureEnabled('general_analytics')) {
            userFlowState.setCalculateRequired({isRequired: true, postponeForLocation: null});
        } else {
            userFlowState.setPartialCalculateRequired({isRequired: true, postponeForLocation: null});
        }
    }

    const [isOpen, setIsOpen] = useState(false);

    const firstNotice = updateNotices.length ? updateNotices[0] : null;
    let tailNotices = updateNotices.slice(1);

    if (!canRecalculate && mode=='silent') return (<></>);

    return (
        <>
            <Paper
                sx={{
                    pt: 2, pl: 2, pr: 2,
                    pb: (isOpen && tailNotices.length > 0) ? 2 : 0,
                    fontSize: "14px",
                    textAlign: "left",
                    mb: mode=="silent"?2:0,
                    overflowX: "hidden",
                }}
            >
                {canRecalculate ?
                        <ReportProblemOutlinedIcon sx={{
                            float: "left", width: "25px", height: "25px", m: "5px", mr: "10px", mt: "0",
                            color: theme.palette.warning.main,
                        }} />
                        :
                        <InfoOutlinedIcon sx={{
                            float: "left", width: "25px", height: "25px", m: "5px", mr: "10px", mt: "0",
                            color: theme.palette.info.main,
                        }} />
                }

                {mode!='silent' ?
                <Box sx={{
                    mb: 1,
                    fontWeight: "bold",
                    color: "rgba(0, 0, 0, 0.6)",
                    mt: 0.2,
                }}>
                    Nestarenie.Expert {t("обновлён")} <Box component="span" sx={{whiteSpace: "nowrap"}}>{formatDate(algorithm.algorithm_date, true)}</Box>
                </Box>
		:null}
                {panel.lang!=i18n.language?
                <Box sx={{ mb: 1, fontWeight: "bold", color: "rgba(0, 0, 0, 0.6)", mt: 0.2, }}>{t("Язык переключён")}</Box>
		: null }

                {firstNotice ?
                    <Box sx={{
                        color: "rgba(0, 0, 0, 0.6)",
                        clear: "both",
                        overflowX: "hidden",
                    }}>
                        <b>{formatDate(firstNotice.created_at, false)}:</b> {" "}
                        <Linkify text={firstNotice.text} />
                    </Box>
                    : null
                }

                {canRecalculate ?
                    <Box sx={{
                        mt: 2,
                        mb: tailNotices.length === 0 ? 2 : 0,
                        textAlign: "center",
                    }}>
                        <Button
                            variant="contained"
                            size="small"
                            sx={{ lineHeight: "1.4", p: 2, pt: 1.5, pb: 1.5 }}
                            onClick={calculateAll}
                        >
                            {t("Пересчитать ваши результаты")}
                        </Button>
                    </Box>
                    : null
                }

                {tailNotices.length ?
                    <>
                        <Box sx={{
                            textAlign: "right", width: "100%",
                        }}>
                            <Button
                                variant="text"
                                sx={{
                                    textTransform: "lowercase",
                                    backgroundColor: "rgba(255,255,255, 0.3)",
                                    position: "relative",
                                    right: "-15px",
                                }}
                                size="small"
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                {isOpen ? <>{t("скрыть")}</> : <>{t("ещё")}</>}
                            </Button>
                        </Box>
                        <Collapse in={isOpen}>
                            {updateNotices.slice(1).map((notice, i) => (
                                <Box key={i} sx={{
                                    mb: 1,
                                    mt: 1,
                                    color: "rgba(0, 0, 0, 0.6)",
                                    overflowX: "hidden",
                                }}>
                                    <b>{formatDate(notice.created_at, false)}:</b> {" "}
                                    <Linkify text={notice.text} />
                                </Box>
                            ))
                            }
                        </Collapse>
                    </>
                    : null
                }
            </Paper>
        </>
    );
}
